import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../Common/snackbar/action";
import "./csscomponents/CarInfoCards.css";

export default function Overview(props) {
  const dispatch = useDispatch();

  const [registerationYear, setRegisterationYear] = useState("");
  const [manufacturingYear, setManufacturingYear] = useState("");
  const [owners, setOwners] = useState("");
  const [transmission, setTransmission] = useState("");
  const [color, setColor] = useState("");
  const [insurance, setInsurance] = useState("");
  const [registerationType, setregisterationType] = useState("");
  const [description, setDescription] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (props.client.oldCarId !== "") {
      props.addOverview(
        props.login.token,
        props.login.user_id,
        props.client.oldCarId,
        registerationYear,
        manufacturingYear,
        owners,
        transmission,
        color,
        insurance,
        registerationType,
        description
      );
      navigate("/specification");
    }
  };

  return (
    <div className="car-form-container">
      <div className="car-form-card">
        <h2 className="form-title">Overview</h2>

        <form onSubmit={handleSubmit} className="car-form">
          <div className="form-fields">

            {/* Registration Year */}
            <div className="form-group">
              <label>Registration Year</label>
              <select
                value={registerationYear}
                onChange={(e) => setRegisterationYear(e.target.value)}
                required
              >
                <option value="">Select Year</option>
                {[...Array(15)].map((_, i) => {
                  const year = 2024 - i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </div>

            {/* Manufacturing Year */}
            <div className="form-group">
              <label>Manufacturing Year</label>
              <select
                value={manufacturingYear}
                onChange={(e) => setManufacturingYear(e.target.value)}
                required
              >
                <option value="">Select Year</option>
                {[...Array(15)].map((_, i) => {
                  const year = 2024 - i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </div>

            {/* Owners */}
            <div className="form-group">
              <label>No. of Owners</label>
              <select
                value={owners}
                onChange={(e) => setOwners(e.target.value)}
                required
              >
                <option value="">Select</option>
                <option value="First Owner">First Owner</option>
                <option value="Second Owner">Second Owner</option>
                <option value="Third or More">Third or More</option>
                <option value="Unregistered Car">Unregistered Car</option>
              </select>
            </div>

            {/* Transmission */}
            <div className="form-group">
              <label>Transmission</label>
              <select
                value={transmission}
                onChange={(e) => setTransmission(e.target.value)}
                required
              >
                <option value="">Select</option>
                <option value="Automatic">Automatic</option>
                <option value="Manual">Manual</option>
                <option value="Clutchless Manual">Clutchless Manual</option>
              </select>
            </div>

            {/* Color */}
            <div className="form-group">
              <label>Color</label>
              <input
                type="text"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                required
              />
            </div>

            {/* Insurance */}
            <div className="form-group">
              <label>Insurance</label>
              <input
                type="text"
                value={insurance}
                onChange={(e) => setInsurance(e.target.value)}
                required
              />
            </div>

            {/* Registration Type */}
            <div className="form-group">
              <label>Registration Type</label>
              <select
                value={registerationType}
                onChange={(e) => setregisterationType(e.target.value)}
                required
              >
                <option value="">Select</option>
                <option value="private">Private</option>
                <option value="commercial">Commercial</option>
              </select>
            </div>

          </div>

          {/* Seller Comment */}
          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
          </div>

          <div className="form-submit">
            <button type="submit">Next</button>
          </div>
        </form>
      </div>

      <LoaderCon />

      <Snackbar1
        open={props.snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={props.snackbar.message}
      />
    </div>
  );
}
